import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllBoardingPoints = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/boarding-points',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveBoardingPoint = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/boarding-points',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateBoardingPoint = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/boarding-points/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteBoardingPoint = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/boarding-points/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllBoardingPoints,
  saveBoardingPoint,
  deleteBoardingPoint,
  updateBoardingPoint,
}
